<!--
 * @Description: 服务事项配置模板详情组件
 * @Author: sunhuihong
 * @Date: 2022-05-26 15:43:52
 * @LastEditTime: 2022-12-27 16:35:09
-->
<template>
  <div class="view-matter-cfg-details">
    <div class="view-matter-cfg-details-left">
      <div class="view-matter-cfg-details-left-title">
        <div>
          <span class="title-line"></span>
          <span style="font-size: 15px; color: #000000; font-weight: 600;">服务组类</span>
        </div>
        <el-button  type="text" icon="el-icon-circle-plus" class="add-group-button" @click="handleAddGroup">新增组</el-button>
      </div>
      <el-input placeholder="输入关键字进行过滤" size="small" v-model="filterServiceItemGroup" suffix-icon="el-icon-search">
      </el-input>
      <el-tree :style="treeHeight" class="tree-style" :data="matterCfgData" :props="defaultProps" node-key="id"
        :default-expanded-keys="[choiceId]" :filter-node-method="filterNode" highlight-current ref="tree"
        @node-click="deptNodeClick">
        <span class="custom-tree-node" slot-scope="{ node, data }" @mouseover="mouseover(data)" @mouseleave="mouseout(data)">
          <span class="tree-label-style"> 
            {{ node.label }}
          </span>
          <div  v-show="data.dropdownShow" style="flex: 1; text-align: right">
            <el-dropdown placement="bottom-end" trigger="hover" size="medium">
              <img class="tree-more" v-show="data.name !== '预约须知组'&& data.name !== '服务标准及保障组' 
                && data.name !== '预约须知' && data.name !== '服务标准及保障'" src="@/assets/hsvcmng/icon-hsvcmng-more.png" 
                alt="" >
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item  @click.native="handleAddTemplate(node,data)" v-show="data.parentId == 0">
                  新增模板
                </el-dropdown-item>
                <el-dropdown-item  @click.native="handleEditName(node,data)">修改名称</el-dropdown-item>
                <el-dropdown-item  @click.native="handleDeleteGroup(node,data)">
                  {{data.parentId == 0 ? '删除分组' : '删除模板'}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </span>
      </el-tree>
    </div>
    <div class="main-line"  :style="lineHeight"></div>
    <div class="view-matter-cfg-details-right">
      <el-row style="margin: 12px 10px 10px 35px;">
        <el-form v-show="showContent && matterCfgData.length && this.ruleForm.parentId !== 0"
          :rules="rules" :model="ruleForm" ref="ruleForm">
          <el-form-item  prop="content" >
            <div style="margin: 0 0 10px 0; font-weight: 400; color: #657180;">{{title}}:</div>
            <el-input  type="textarea" ref="content" v-model="ruleForm.content" :disabled="readonly" 
              maxlength="500" :rows="16" placeholder="请输入注意事项" style="width: 70%;">
            </el-input>
          </el-form-item>
          <div >
            <el-button @click="handleCancel"  class="edit-button-style" v-if="cancleButton">取 消</el-button>
            <el-button type="primary" class="edit-button-style" v-else @click="handleEditContent">修 改</el-button>
            <el-button type="primary" class="submit-button-style" v-show="showSubmitButton" @click="handleSubmit('ruleForm')">
              确 定
            </el-button>
          </div>
        </el-form>
      </el-row>
    </div>
  </div>
</template>
<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'MatterCfgDetails',
  props: ["matterCfgData","currentMatterCfgData",],
  data() {
    let validateContent = (_rule, _value, callback) => {
			if (this.ruleForm.content && this.ruleForm.content.trim().length == 0) {
				callback(new Error('注意事项不能输入全空格或全换行'));
			} else if (this.ruleForm.content == '') {
				callback(new Error('请输入注意事项'));
			} else {
        callback();
      }
    };

    return {
      filterServiceItemGroup : '',
      defaultProps: {
        children: 'matterCfgDTOList',
        label: 'name',
     }, 
      id : '',
      choiceId : '',
      ruleForm : {
        name : '',
        parentId : '',
        content : '',
      },
      showContent : true,
      showSubmitButton : false,
      title : '注意事项',
      readonly : true,
      cancleButton : false,
      rules:{
        content: [
          { required: true,validator: validateContent, trigger: 'blur'},
          { min: 1, max: 500, message: '长度在 1 到 500个字符', trigger: 'blur' }
        ],     
      },
    }
  },
  
  computed: {
    lineHeight() {
      return 'height:' + (this.$root.windowHeight - 90) + 'px';
    },

    treeHeight() {
      return 'height:' + (this.$root.windowHeight - 194) + 'px';
    },  
  },

  watch: {
    filterServiceItemGroup(val) {
      this.$refs.tree.filter(val);
    },

    matterCfgData(data) {
      //第一次的choiceId设置为第一个数据，若之后设置了选中则无需更改
      this.choiceId = !this.choiceId  ? data[0].id : this.choiceId;
      //设置选中
      this.$nextTick(() => {
        if (data.length  && data[0].matterCfgDTOList.length ) {
          this.$refs.tree.setCurrentKey(data[0].matterCfgDTOList[0].id)
        } else {
          this.$refs.tree.setCurrentKey(this.choiceId)
        }
      })
      this.ruleForm.content = data[0].matterCfgDTOList.length  ?  data[0].matterCfgDTOList[0].content : '';
      this.id = data[0].matterCfgDTOList.length  ? data[0].matterCfgDTOList[0].id : '';
      this.ruleForm.parentId = data[0].matterCfgDTOList.length  ? data[0].id : '';
      this.ruleForm.name = data[0].matterCfgDTOList.length  ? data[0].matterCfgDTOList[0].name : '';
    },

    currentMatterCfgData(newVal, _oldVal){
      if (newVal && Object.keys(newVal).length) {
        this.choiceId = newVal.id;
        this.ruleForm.parentId = newVal.parentId;
        this.ruleForm.name = newVal.name;
        this.id = newVal.id;
      }
    }
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    // 移入
    mouseover (data) { 
      this.$set(data, 'dropdownShow', true)
    },

    // 移除
    mouseout (data) { 
      this.$set(data, 'dropdownShow', false)
    },
    
    //新增组
    handleAddGroup() {
      this.showContent = false;
      this.$emit("handle-add-group",true)
    },
    
    //新增模板
    handleAddTemplate(_node,data) {
      this.$refs.content.focus();
      this.cancleButton = true;
      this.readonly = false;
      this.showSubmitButton = true;
      this.showContent = true;
      this.$emit("handle-add-template", data);
    },

    //编辑组或者模板
    handleEditName(_node,data) {
      this.choiceId = data.id
      this.$emit("handle-edit-name", data);
    },
    
    //删除组或者模板
    handleDeleteGroup(_node,data) {
      this.$emit("handle-delete-group", data);
    },

    //编辑注意事项内容
    handleEditContent() {
      this.readonly = false;
      this.showSubmitButton = true;
    },
    
    //编辑成功后确认提交编辑的注意事项
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if(!valid)return false;
        this.ruleForm.id = this.id;
        let header = this.encryptionUtil.signatureBody(this.ruleForm,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'PUT',
          url: Constant.URL_UPDATW_MATTER_CFG,
          param: this.ruleForm,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) return;
          this.$parent.getMatterCfgData();
          this.$message({message: '保存成功', type: 'success'});
        })
      }) 
    },

    //根据服务事项名字展示content内容的title
    getContentTitle(item) {
      switch(item.name) {
        case "预约须知"  :
          this.title = '预约须知';
          break;
        case "预约须知组" :
          this.title = '预约须知';
          break;
        case "服务标准及保障组" :
          this.title = '服务标准及保障';
          break;  
        case "服务标准及保障" :
          this.title = '服务标准及保障';
          break;
        default :
          this.title = '注意事项';
          break;
      }
    },

    deptNodeClick(item,_e) {
      this.showContent = item.parentId == 0 ? false : true;
      this.ruleForm.content = item.content;
      this.ruleForm.parentId = item.parentId;
      this.ruleForm.name = item.name;
      this.id = item.id;
      this.getContentTitle(item);
    },

    handleCancel() {
      this.ruleForm.content = '';
    },
  },
}
</script>

<style>
.view-matter-cfg-details .el-tree-node__content {
  height: 36px;
  line-height: 36px;
}

.view-matter-cfg-details-right .el-textarea__inner {
  padding: 16px 30px 12px 16px;
}
</style>
<style scoped >
.view-matter-cfg-details {
  display: flex;
  justify-content: space-between;
}

.view-matter-cfg-details-left {
  padding: 6px 23px 16px 0;
  width: 250px;
}

.view-matter-cfg-details-left-title {
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  margin-bottom: 8px;
}

.view-matter-cfg-details .title-line {
  display: inline-block;
  width: 4px;
  height: 14px;
  background: #3E7EF5;
  border-radius: 2px;
  vertical-align: middle;
  margin-right: 4px;
}

.view-matter-cfg-details .main-line {
  width: 10px;
  background-color: #f0f0f0;
}

.view-matter-cfg-details .add-group-button {
  font-size: 14px;
}

.view-matter-cfg-details .tree-style {
  margin-top: 10px;
  overflow-y: auto;
}

.view-matter-cfg-details .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 10px;
  height:100%;
}

.view-matter-cfg-details .tree-more {
  width:14px;
  height:14px;
}

.view-matter-cfg-details .tree-label-style {
  width: 160px;
  text-align: left;
  color: #7689A6;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.view-matter-cfg-details .view-matter-cfg-details-right {
  flex: 1;
  text-align: left;
}

.view-matter-cfg-details .edit-button-style {
  width: 80px;
  height: 30px;
  line-height: 5px;
}

.view-matter-cfg-details .submit-button-style {
  width: 80px;
  height: 30px;
  line-height: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/hsvccfg/components/MatterCfgDetails.vue